export class Level {
    constructor(physics) {
		if (!physics) throw new Error('parameter physics is missing')
		this.physics = physics;
		this.plattformGroup = physics.add.staticGroup();
		this.level = 1;
		this.placeLedgers(this.plattformGroup, this.level)
    }

	nr() {
		return this.level
	}

	addCollider(collidingThing) {
		if (!this.physics) {
			throw new Error("invalid setup: physics missing")
		}
		this.physics.add.collider(collidingThing, this.plattformGroup);
	}

	//lvlup
	up() {
		this.level++
		this.plattformGroup.clear(true, true);
		this.placeLedgers(this.plattformGroup, this.level)
	}

    placeLedgers(p, level) {
		const phaserioExample=[{x: 600, y: 400, scaleWidth: 1}, {x: 50, y: 250, scaleWidth: 1}, {x: 750, y: 220, scaleWidth: 1}]
		
		const all = [
			phaserioExample,
			[{ x: 300, y: 440 }, { x: 50, y: 140 }, { x: 300, y: 210 }, { x: 550, y: 300 }],
			[{ x: 650, y: 450 }, { x: 50, y: 400 }, { x: 250, y: 260, }, { x: 700, y: 190, scaleWidth: .6 }],
			[// level2
				{ x: 0, y: 458, scaleWidth: .3 },
				{ x: 251, y: 376, scaleWidth: .3 },
				{ x: 472, y: 307, scaleWidth: .3 },
				{ x: 675, y: 218, scaleWidth: .3 }
			],
			[ // level3
				{ x: 0, y: 458, scaleWidth: .3 },
				{ x: 133, y: 311, scaleWidth: .3 },
				{ x: 272, y: 186, scaleWidth: .3 },
				{ x: 630, y: 78, scaleWidth: 1 }
			],

			[// level4
				{ x: 0, y: 458, scaleWidth: .3 },
				{ x: 133, y: 330, scaleWidth: .3 },
				{ x: 444, y: 327, scaleWidth: .3 },
				{ x: 713, y: 327, scaleWidth: .3 }
			],

			[//level-5
				{ x: 0, y: 458, scaleWidth: .3 },
				{ x: 140, y: 330, scaleWidth: .3 },
				{ x: 444, y: 327, scaleWidth: .3 },
				{ x: 657, y: 205, scaleWidth: .16 },
				{ x: 747, y: 65, scaleWidth: .16 }
			],
			[//level1 war aber zu schwer als 1. ;)
			{ x: 235, y: 337, scaleWidth: .3 },
			{ x: 491, y: 260, scaleWidth: .3 },
			{ x: 0, y: 454, scaleWidth: .3 },
			{ x: 702, y: 335, scaleWidth: .3 },
			{ x: 360, y: 135, scaleWidth: .3 }
			]
		];

		const levelInArray = level<all.length?level-1:0
		
		all[levelInArray].forEach(l => 
			p.create(l.x, l.y, 'ground').setScale(l.scaleWidth || .4, 1).refreshBody()
		)
    }
}